module.exports = __webpack_public_path__ + "static/img/Serve12_2@2x.9d29839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Serve12_2@2x.png
// module id = EWKD
// module chunks = 1